import React from "react";
import { View } from "@amzn/stencil-react-components/layout";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";

/**
 * Minimal loading placeholder for the campaigns route -- unlike
 * {@link AppSkeleton}, it never renders the shop `HeaderSkeleton`, since
 * `/campaigns` has no header of its own.
 */
export const CampaignsSkeleton: React.FC = () => {
  return (
    <View padding="S700" aria-busy="true" aria-label="Loading campaigns" data-testid="campaigns-skeleton">
      <Spinner size={SpinnerSize.Medium} />
    </View>
  );
};
